/**
 * Referrals (1.2): what has come in and has not been decided. Its own route and
 * its own item in the OPERATE menu, because the person deciding referrals and
 * the person working pending admissions may be different people.
 *
 * Nothing on this page carries a status: a referral is here because nobody has
 * decided it yet. Accept moves it to Pending admissions; Release removes it from
 * both.
 */
import { Alert, Box, Link as MuiLink, Typography } from "@mui/material";
import { Link as RouterLink, useLocation, useParams } from "react-router-dom";
import { useDemoSelector } from "../../store/useDemoStore";
import { ReferralPanel } from "./ReferralPanel";
import { ReferralQueue } from "./ReferralQueue";

export function ReferralsPage() {
  const { referralId } = useParams<{ referralId?: string }>();
  const branch = useDemoSelector((s) => s.config.branch.name);
  // The panel closes on a one-line receipt after Accept: it travels here with the navigation,
  // and ends on a link to where the accepted referral went (Pete, 2026-10-12).
  const receipt = (useLocation().state as { receipt?: string } | null)?.receipt;

  return (
    <Box sx={{ py: 2 }}>
      <Box sx={{ display: "flex", alignItems: "baseline", gap: 1, mb: 2 }}>
        <Typography variant="h5">Referrals</Typography>
        <Typography variant="body2" color="text.secondary">
          {branch}
        </Typography>
      </Box>
      <Box sx={{ display: "flex", flexDirection: "column", gap: 2 }}>
        {receipt && !referralId && (
          <Alert severity="success" variant="outlined">
            {receipt}{" "}
            <MuiLink component={RouterLink} to="/pending-admissions">
              Pending Admissions
            </MuiLink>
          </Alert>
        )}
        <ReferralQueue selectedId={referralId} />
        {/* Nothing where the panel would be until a row is picked: the queue
            beside it is the invitation (Pete, 2026-09-22). */}
        {referralId && <ReferralPanel referralId={referralId} />}
      </Box>
    </Box>
  );
}
